import { CreateEventNow } from './components/create-event-now';
import { Footer } from './components/footer';
import { Hero } from './components/hero';
import { Integration } from './components/integration';
import { Presentation } from './components/presentation';
import { SellTickets } from './components/sell-tickets';
import { Tagline } from './components/tagline';
import { UnforgattableEvents } from './components/unforgettable-events';

export const Home = () => {
  return (
    <div className='bg-ctx-layout-surface'>
      <Hero />
      <Presentation />
      <Integration />
      <CreateEventNow />
      <SellTickets />
      <UnforgattableEvents />
      <Tagline />
      <Footer />
    </div>
  );
};
